<template>
  <div class="content">

    <div class="steps-content">
      <!-- 填写预约信息 -->
      <div v-if="current == 0">
        <a-form :form="form">
          <!-- 正常表单 -->
          <div class="flexline">
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="姓名">
              <a-input v-decorator="[
          'name',
          { rules: [{ required: true, message: '请输入合法姓名',pattern:/^([\u4e00-\u9fa5]{2,15})$/}] },
        ]" placeholder="请输入姓名" />
            </a-form-item>
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="护照号">
              <a-input v-decorator="[
          'passportId',
          { rules: [{ required: true, message: '请输入护照号'}] },
        ]" placeholder="请输入护照号" />
            </a-form-item>
          </div>
          <!-- 正常表单 -->
          <div class="flexline">
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="受理号">
              <a-input v-decorator="[
          'handleId',
          { rules: [{ required: true, message: '请输入受理号'}] },
        ]" placeholder="请输入受理号" />
            </a-form-item>
          </div>
        </a-form>
      </div>

      <div v-if="current == 1">
        <div class="content-box" id="maindiv">
          <div style="margin: 0 1.9cm;width: 80%;">

            <div style="font-weight:600;color: black;text-align:center;font-size:30px;margin: 70px 0;">日本签证预约回执单</div>
            <div class="line1">
              <div style="font-weight:600;font-size:18px;color: black;word-spacing: 4px;">预 约 号:</div>
              <div style="border-bottom: 1px solid black;width: 300px;text-indent:20px">{{orderInfo.reserveId}}</div>
            </div>
            <div class="line1">
              <div style="font-weight:600;font-size:18px;color: black;letter-spacing: 0px;">预约时间:</div>
              <div style="border-bottom: 1px solid black;width: 300px;text-indent:20px">{{orderInfo.reserveDate}}&nbsp; {{orderInfo.timeRange}}</div>
            </div>
            <div class="line1">
              <div style="font-weight:600;font-size:18px; color: black;word-spacing:30px;">姓 名:</div>
              <div style="border-bottom: 1px solid black;width: 300px;text-indent:20px">{{orderInfo.name}}</div>
            </div>

            <div class="line1">
              <div style="font-weight:600;font-size:18px;color: black;;word-spacing: 4px;">护 照 号:</div>
              <div style="border-bottom: 1px solid black;width: 300px;text-indent:20px">{{orderInfo.passportId}}</div>
            </div>

            <div class="line1">
              <div style="font-weight:600;font-size:18px;color: black;">签证类别:</div>
              <div style="border-bottom: 1px solid black;width: 300px;text-indent:20px">{{orderInfo.visaTypeName}}({{orderInfo.stayTypeName}})</div>
            </div>

            <div class="line1">
              <div style="font-weight:600;font-size:18px;color: black;">联系电话:</div>
              <div style="border-bottom: 1px solid black;width: 300px;text-indent:20px">{{orderInfo.mobilePhone}}</div>
            </div>

            <div class="line1">
              <div style="font-weight:600;font-size:18px;color: black;word-spacing:30px;">状 态:</div>
              <div style="border-bottom: 1px solid black;width: 300px;text-indent:20px">{{orderInfo.verifyStatusName}}</div>
            </div>

            <div class="line">
              <span style="font-weight:600;font-size:18px;color: black;">备注:</span>
              <div class="beizhu">
                <div>
                  <div>1、请申请人凭此预约单及签证所需材料，按预约时间进入日本签证受理大厅办理签证。</div>
                  <div>2、此预约单上的预约号不是签证受理顺序号，申请人到达受理大厅按排队顺序获取签证受理号。</div>
                </div>
                <div>
                  3、签证所需材料及表格下载请参考网址：
                  <div>
                    <a class="gold-font" href="http://www.ffasc.cn/templates/template2/4/page.ftl?LXBS=CJQZ_RBQZ_PRGLQZZXCL&sjlxbs=CJQZ&LXID=47" target="_blank">http://www.ffasc.cn/templates/template2/4/page.ftl?LXBS=CJQZ_RBQZ_PRGLQZZXCL&sjlxbs=CJQZ&LXID=47</a>
                  </div>
                </div>
                <div>
                  请务必准备好所需材料，填好信息表等表格，否则将会影响您在现场的办理速度
                </div>
                <div>
                  4、签证受理流程：
                  <div style="margin-top:10px">
                    <img src="@/assets/process.png" alt="" style="width: 98%;margin-left: 1px;">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="steps-action">
      <a-button v-if="current == 0" type="primary" @click="selectOrder()">查看预约</a-button>
      <a-button v-if="(current == 1 && print == true)" type="primary" @click="cancelOrder">取消预约</a-button>
      <a-button v-if="(current == 1 && print == true)" type="primary" @click="printF()">打印回执</a-button>
    </div>

  </div>
</template>

<script>

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 15 },
};

const selectItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 15 },
};
import { cancelOrder, orderReserve } from "@/api/goaborad";
import { printHtml } from "@/util/exportPdf.js";
import { Modal } from 'ant-design-vue';
export default {
  name: "hover-box",
  data () {
    return {
      current: 0,
      formItemLayout,
      selectItemLayout,
      form: this.$form.createForm(this, { name: 'dynamic_rule' }),
      nextStep: 'no',
      orderInfo: [],
      print: true
    };
  },
  created () {
    this.getTime()
  },
  methods: {
    selectOrder () {  //查看预约
      this.form.validateFields((err, values) => {
        if (!err) {
          if (typeof (values.reserveDate1) === 'undefined') {
            values.reserveDate1 = ''
          }
          orderReserve(values.name, values.passportId, values.reserveDate1).then((res) => {
            if (res.data.records) {
              this.orderInfo = res.data.records[0]
              let orderTime = new Date(this.orderInfo.reserveDate + ' ' + (this.orderInfo.timeRange).substring(6, 11))
              this.current = 1
            } else {
              alert('没有查询到预约记录')
            }
          })
        }
      });
    },
    printF () {
      let dom = document.querySelector("#maindiv").innerHTML;
      printHtml(dom);
    },
    cancelOrder () {  //取消预约
      var _this = this
      Modal.confirm({
        title: '取消预约',
        content: '三天内取消预约2次当日不可再次预约,确认取消?',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          console.log(_this.orderInfo);
          let params = {
            tableDataIds: [_this.orderInfo.id]
          }
          cancelOrder(params).then((res) => {
            _this.orderInfo.verifyStatusName = '已取消'
            _this.print = false
            _this.$message.success(res.message)
          })
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onCancel () { },
      });

    },
    getTime () {  //获取当前时间
      let time = new Date()
      return time.getTime()
    },
  }
};
</script>


<style lang="less" scoped>
.content {
  // text-align: center;
  padding-top: 20px;
  font-family: Microsoft YaHei;
  // width: 800px;
}

.steps-box {
  margin: 0 auto;
  // display: flex !important;
  // justify-content: center;
}
.second-title {
  margin: 20px 0;
  text-align: left;
  color: rgb(198, 200, 199);
}
.steps-content {
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: rgb(250, 251, 251);
  // min-height: 330px;
  text-align: center;
  padding: 30px 0;
}

.steps-action {
  margin-top: 24px;
}

[data-theme="dark"] .steps-content {
  background-color: #2f2f2f;
  border: 1px dashed #404040;
}
.attention-info {
  text-align: left;
  margin: 20px 30px 0 0;
  line-height: 40px;
  text-align: justify;
  text-justify: inter-ideograph;
  font-size: 16px;
}

.flexline {
  display: flex;
}
.flexline .ant-row {
  width: 50%;
}

/deep/.ant-form-item-children {
  display: flex;
}

/deep/.ant-form-explain {
  text-align: left;
}

.title {
  font-size: 18px;
  font-weight: 600;
  display: flex;
  justify-content: left;
  color: rgb(198, 200, 199);
}
.tab-box:nth-child(2) {
  margin: 0 20px;
  // border-bottom: 2px solid rgb(203, 180, 134);
}
.tab-box:hover {
  cursor: pointer;
}

.content-box {
  width: 85%;
  text-align: left;
}
.line {
  margin-top: 20px;
  font-size: 17px;
}
.line1 {
  margin-top: 20px;
  font-size: 17px;
  display: flex;
}
.beizhu {
  margin-left: 50px;
  margin-top: -33px;
  line-height: 40px;
}

// 按钮颜色改为金色2022-12-16
.ant-btn-primary {
  background-color: #cbb486 !important;
  border-color: #cbb486 !important;
}

.ant-btn-danger {
  background-color: #cbb486 !important;
  border-color: #cbb486 !important;
}
.ant-btn {
  background-color: #cbb486 !important;
  border-color: #cbb486 !important;
}
.gold-font {
  color: #cbb486;
}
</style>


// WEBPACK FOOTER //
// src/components/home/query/components/content-02.vue